export default __webpack_public_path__ + "static/media/p2.dc66d90f.jpg";